<template>
  <v-row align="center">
    <v-btn
      class="button-cta color-white background-primary"
      :class="[{'background-danger' : isLive && isTeacher}]"
      depressed
      rounded
      block
      @click="click"
    >
      <!-- eslint-disable-next-line max-len -->
      {{ isTeacher ? buttonText : `${isWaving || wavingTimeout ? $t('wavingHand') : $t('waveHand')}` }} {{ isWaving || wavingTimeout ? wavingTimeout + 's' : '' }}
    </v-btn>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ButtonCta',
  props: {
    lessonData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    wavingTimeout(next, prev) {
      if (!prev && next) {
        const interval = setInterval(() => {
          if (this.wavingTimeout > 0) this.wavingTimeout -= 1;
          else clearInterval(interval);
        }, 1000);
      }
    },
  },
  data() {
    return {
      wavingTimeout: 0,
      textOptions: {
        draft: this.$t('buttonTextLessonStart'),
        live: this.$t('buttonTextLessonEnd'),
        ended: this.$t('Konec'),
      },
    };
  },
  computed: {
    ...mapGetters(['auth']),
    // ID lekce
    lessonId() {
      return this.$route.params.lesson;
    },
    // Text shown on button
    buttonText() {
      return this.textOptions[this.currentStatus];
    },
    // Next status, will be emitted after click
    nextStatus() {
      switch (this.currentStatus) {
        case 'draft':
          return 'live';
        case 'live':
          return 'ended';
        default:
          // switch back to draft status
          return 'draft';
      }
    },
    // current status
    currentStatus() {
      return this.lessonData.status;
    },

    // is live
    isLive() {
      return this.currentStatus === 'live';
    },

    // is teacher
    isTeacher() {
      return !this.$route.params.viewer;
    },

    // viewer data
    viewer() {
      return !this.isTeacher
        ? this.lessonData.viewers[this.$route.params.viewer]
        : null;
    },

    // is waving
    isWaving() {
      return this.viewer && this.viewer.waving;
    },
  },
  methods: {
    switchStatus() {
      this.$store.dispatch('statusChange', {
        email: this.auth.email,
        lesson: this.lessonId,
        value: this.nextStatus,
      });

      if (this.isLive) {
        this.$store.dispatch('logEvent', {
          name: 'lesson_ended',
        });
      }
    },
    startWaving() {
      this.$store.dispatch('viewerUpdate', {
        viewer: this.$route.params.viewer,
        value: true,
        action: 'waving',
        lesson: this.$route.params.lesson,
      });
      this.$store.dispatch('logEvent', {
        name: 'viewer_waved',
      });

      setTimeout(() => {
        this.wavingTimeout = 10;
      }, 250);
    },
    click() {
      if (this.isTeacher) {
        this.switchStatus();
      } else if (!this.isWaving) {
        this.startWaving();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-cta {
  min-width: 280px !important;
  height: 56px !important;
}
@media only screen and (max-width: 1536px) and (min-width: 1290px) {
  .button-dropdown,
  .button-cta {
    width: 230px !important;
    min-width: 0px !important;
    min-width: 0px !important;
  }
}
@media only screen and (max-width: 1289px) and (min-width: 1141px) {
  .button-dropdown,
  .button-cta {
    width: 230px !important;
    min-width: 0px !important;
    min-width: 0px !important;
  }
}

@media only screen and (max-width: 1140px) and (min-width: 1025px) {
  .button-cta {
    width: 180px !important;
    min-width: 0px !important;
    min-width: 0px !important;
  }
}

@media (max-width: 1024px) {
  .button-cta {
    width: 190px !important;
    min-width: 0px !important;
    height: 46px !important;
  }
}

@media (max-width: 1440px) {
  .button-cta {
    height: 46px !important;
  }
}
</style>
